// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignShipToAddressModalStyles } from "@tps/Overrides/Widgets/UserSetup/AssignShipToAddressModal";
import { modalButtonsActionStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

assignShipToAddressModalStyles.modal = { sizeVariant: "large" };

assignShipToAddressModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

assignShipToAddressModalStyles.addressInfoDisplay = {
    address1Text: {
        css: css`
            margin-top: 0;
        `,
    },
};

assignShipToAddressModalStyles.shipToNumberGridItem = {
    width: [4, 3, 2, 2, 2],
    css: css`
        flex-direction: column;
    `,
};
assignShipToAddressModalStyles.addressInfoGridItem = {
    width: [8, 5, 6, 6, 7],
};
